import { useCallback } from 'react';

import { PaginationProps } from 'semantic-ui-react';

import { GenericTable, SortSelector } from '@publicisgroupe/p-os-components';

import { GenericTableShortProps } from './interfaces';

import { TableState } from './types';
import { ThemeDetails } from 'interfaces/ThemeDetails';

interface GenericLibraryProps {
  genericTableProps: GenericTableShortProps<ThemeDetails>;
  tableState: TableState<ThemeDetails>;
  onSort: (selector: SortSelector<ThemeDetails, any>) => void;
  onPageChange: (paginationProps: PaginationProps) => void;
  pageCount: number;
}

export const GenericLibrary = ({
  genericTableProps,
  tableState,
  onSort,
  onPageChange,
  pageCount,
}: GenericLibraryProps) => {
  const handlePageChange = useCallback(
    (_event: any, data: PaginationProps) => {
      onPageChange(data);
    },
    [onPageChange]
  );

  return (
    <div className="main-row">
      <GenericTable
        className="p-os-grid"
        getId={(item) => item.id}
        columnDefinitions={genericTableProps.columnDefinitions}
        hidePagination={pageCount < 1}
        noDataFoundMessage={genericTableProps.noDataFoundMessage}
        actions={genericTableProps.actions}
        pageIndex={tableState.pageIndex}
        pageSize={tableState.pageSize}
        pageCount={genericTableProps.pageCount}
        onPageChange={handlePageChange}
        sortState={tableState.sortState}
        data={tableState.data}
        onSort={onSort}
      />
    </div>
  );
};
